import { createFileRoute } from '@tanstack/react-router'

import { GlobalRoleType } from '@beaded/models'

import { requireGlobalRole } from 'lib/routeGuards'

import PageTypeAdmin from 'pages/PageAdmin/PageTypeAdmin'

export const Route = createFileRoute('/_auth/_global/page-admin/$pageType/')({
  beforeLoad: requireGlobalRole(GlobalRoleType.GLOBAL_ADMIN),
  component: PageTypeAdmin,
})
